import { AppName, Environment, InstanceTier } from '../app/types/environment.type';

export const environment: Environment = {
  app: AppName.Consumer,
  instance: InstanceTier.Shape,
  brandName: 'BM',
  baseUrl: 'https://bm-shape-server.accuratics.com',
  allowGoogleAnalyticsLog: false,
  allowNetworkDrawer: true,
  allowPushNotification: true,
  allowCrashReporting: false,
  allowBiometricAuth: true,
};
